const SIS = () => {
    return (
        <div> Module is not available?</div>
    )
}

export default SIS;